import React, {useState , useEffect} from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { Row, Col, FormGroup } from "reactstrap";
import axios from "axios";
import {useHistory,useParams} from 'react-router-dom';
import { API_URL } from "../../constent";

import {
  Block,
  BlockHead,
  PreviewCard,
  Button,
  RSelect,
  Icon,
} from "../../components/Component";


var userData = JSON.parse(localStorage.getItem('userData'));
var getuserid = userData?.[0]?.id;

const EditMainSheet = () => {


    const [loading, setLoading] = useState(true);
    const [btnloading, setBtnLoading] = useState(false);
    const [product, SetProduct] = useState([]);
    const [editproduct, SetEditProduct] = useState([]);
    const [files, setFiles] = useState([]);
    const [refresh, setRefresh] = useState(false);

    const history = useHistory();
    const params = useParams()

    var rowid = params.id;
    var category_id = params.catid;
    var policy_type = params.type;



    function submitdata(event){

        event.preventDefault(); // Prevent default form submission behavior
        const form = event.target;
        const data = new FormData(form); // Create FormData object from the form
        const post_data = Object.fromEntries(data.entries());
        post_data['category_id'] = category_id;
        post_data['policy_type'] = policy_type;
        post_data['user_id'] = getuserid;
        post_data['rowid'] = rowid;
        post_data['docs'] = files;

        setBtnLoading(true);

        axios.post(`${API_URL}savemainsheet` , post_data,{
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
            .then((response)=>{
                console.log(response.data);
                if(response.data.Status === 200){
                    setBtnLoading(false);
                    alert(response.data.message);
                    history.push('/');
                }else{
                    setBtnLoading(false);
                    alert(response.data.message);
                }
            })
    }

    const handleInputChange = () => {
      const idv = parseFloat(document.getElementById("idv").value) || 0;
      const el_ass = parseFloat(document.getElementById("el_ass").value) || 0;
      const non_el_ass = parseFloat(document.getElementById("non_el_ass").value) || 0;
      const fuel_kit = parseFloat(document.getElementById("fuel_kit").value) || 0;
      document.getElementById("total_idv").value = idv + el_ass + non_el_ass + fuel_kit;
    }

    const handleInputChange1 = () => {
      const od_premium = parseFloat(document.getElementById("od_premium").value) || 0;
      const liability_premium = parseFloat(document.getElementById("liability_premium").value) || 0;
      const gst = parseFloat(document.getElementById("gst").value) || 0;
      document.getElementById("total_premium").value = od_premium + liability_premium + gst;
    }
    const onFileChange = (e) => {
      setFiles(e.target.files);
    };

    useEffect(() => {
      axios.get( `${API_URL}getsinglepolicy/${category_id}`).then((result)=>
        {
            console.log(result.data);
            SetProduct(result.data);
            setLoading(false);
        }) 

        axios.get( `${API_URL}getsinglesheet/${rowid}/vehicle_policy`).then((result)=>
        {
            console.log(result.data[0]);
            SetEditProduct(result.data[0]);
        }) 

    },[refresh]);

    const deletimage = (index, id) => {
            const updatedDocs = editproduct.docs.filter((_, i) => i !== index);
            SetEditProduct((prev) => ({
              ...prev,
              docs: updatedDocs
            }));
            const post_data = {
              doc: updatedDocs,
              asset_id: id,
              table_name: 'vehicle_policy',
            }
            axios.post(`${API_URL}deletedoc`, post_data).then((result)=>
            { 
                console.log(result.data);
                setRefresh(!refresh);
            })
          };


    if(loading){
        return(
            <>
            <h1>Loading......</h1>
            </>
        )
    }


  return (
    <React.Fragment>
      <Head title={`Edit ${product[0]['policy_name']}`} />
      <Content>

        <Block size="lg">
          <BlockHead>
            <Row className="g-gs">
                  <Col sm="12">
                        <p className="top_head_css">EDIT &gt; {product[0]['policy_name']} &gt; {policy_type == 1?"RENEWAL":"NEW BUSINESS"}</p>
                  </Col>
            </Row>
          </BlockHead>
          <Row className="g-gs">
            <Col lg="12">
              <PreviewCard className="h-100">
                {/* <div className="card-head">
                  <h5 className="card-title">Contact Form</h5>
                </div> */}
                <form onSubmit={submitdata} encType="multipart/form-data">
                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                      PROPOSER
                    </label>
                    <input type="text" id="cf-full-name" defaultValue={editproduct.proposer} name="proposer" className="form-control" />
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                    ADDRESS OF CORRESPONDENCE
                    </label>
                    <input type="text" id="cf-full-name" defaultValue={editproduct.address} name="address" className="form-control" />
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                       POLICY ADDRESS
                    </label>
                    <input type="text" id="cf-full-name" defaultValue={editproduct.policy_address} name="policy_address" className="form-control" />
                  </FormGroup>
                  <Row className="g-gs">
                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          EMAIL ID
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.email_id} name="email_id" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          MOBILE NUMBER
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.phone_number} name="phone_number" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          WHATSAPP NUMBER
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.whatsapp_number} name="whatsapp_number" className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          AADHAR NUMBER
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.aadhar_number} name="aadhar_number" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          PAN NUMBER
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.pan_number} name="pan_number" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                           VEHICLE REGISTRATION  NUMBER
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.vehicle_reg_number} name="vehicle_reg_number" className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          MAKE
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.make} name="make" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                           CHASIS NUMBER
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.chasis_number} name="chasis_number" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          ENGINE NUMBER
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.engine_number} name="engine_number" className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                        REGISTRATION VALIDITY DATE
                        </label>
                        <input type="date" id="cf-full-name"   defaultValue={editproduct.reg_validity_date} name="reg_validity_date" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          CUBIC CAPACITY
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.cubic_capacity}  name="cubic_capacity" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          YEAR OF MANUFACTURE
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.year_manuf} name="year_manuf"  className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          COLOR
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.color} name="color" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                          SEATING CAPACITY
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.seating_capacity} name="seating_capacity" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-4">
                        <label className="form-label" htmlFor="cf-full-name">
                        CUSTOMER ID
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.cust_id} name="cust_id" className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-6">
                        <label className="form-label" htmlFor="cf-full-name">
                          GSTIN
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.gst_number} name="gst_number" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-6">
                        <label className="form-label" htmlFor="cf-full-name">
                        FUEL TYPE
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.fule_type} name="fule_type" className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-6">
                        <label className="form-label" htmlFor="cf-full-name">
                          POLICY START DATE
                        </label>
                        <input type="date" id="cf-full-name" defaultValue={editproduct.policy_status} name="policy_status" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-6">
                        <label className="form-label" htmlFor="cf-full-name">
                          POLICY END DATE
                        </label>
                        <input type="date" id="cf-full-name" defaultValue={editproduct.policy_date} name="policy_date" className="form-control" />
                      </FormGroup>
                    </Row>

                    <Row className="g-gs">
                        <FormGroup className="form-group col-sm-4">
                          <label className="form-label" htmlFor="idv">
                            IDV
                          </label>
                          <input type="text" id="idv" name="idv" defaultValue={editproduct.idv}  onChange={(e) => handleInputChange()}  className="form-control" />
                        </FormGroup>

                        <FormGroup className="form-group col-sm-4">
                          <label className="form-label" htmlFor="el_ass">
                              ELECTRICAL ACCESSORIES
                          </label>
                          <input type="text" id="el_ass" name="el_ass" defaultValue={editproduct.el_ass} onChange={(e) => handleInputChange()} className="form-control" />
                        </FormGroup>

                        <FormGroup className="form-group col-sm-4">
                          <label className="form-label" htmlFor="non_el_ass">
                            NON ELECTRICAL ACCESSORIES
                          </label>
                          <input type="text" id="non_el_ass" name="non_el_ass" defaultValue={editproduct.non_el_ass} onChange={(e) => handleInputChange()} className="form-control" />
                        </FormGroup>

                        <FormGroup className="form-group col-sm-6">
                          <label className="form-label" htmlFor="fuel_kit">
                          BI FUEL KIT
                          </label>
                          <input type="text" id="fuel_kit" name="fuel_kit" defaultValue={editproduct.fuel_kit} onChange={(e) => handleInputChange()} className="form-control" />
                        </FormGroup>

                        <FormGroup className="form-group col-sm-6">
                          <label className="form-label" htmlFor="total_idv">
                            TOTAL IDV
                          </label>
                          <input type="text" id="total_idv" name="total_idv" defaultValue={editproduct.total_idv} className="form-control" readOnly />
                        </FormGroup>
                      </Row>
                      
                      <Row className="g-gs">
                            <FormGroup className="form-group col-sm-3">
                              <label className="form-label" htmlFor="od_premium">
                                  OD PREMIUM
                              </label>
                              <input type="text" id="od_premium" defaultValue={editproduct.od_premium} name="od_premium" onChange={(e) => handleInputChange1()} className="form-control" />
                            </FormGroup>
      
                            <FormGroup className="form-group col-sm-3">
                              <label className="form-label" htmlFor="liability_premium">
                                LIABILITY PREMIUM
                              </label>
                              <input type="text" id="liability_premium" defaultValue={editproduct.liability_premium} name="liability_premium" onChange={(e) => handleInputChange1()} className="form-control" />
                            </FormGroup>
      
                            <FormGroup className="form-group col-sm-3">
                              <label className="form-label" htmlFor="gst">
                                GST
                              </label>
                              <input type="text" id="gst" name="gst" defaultValue={editproduct.gst} onChange={(e) => handleInputChange1()} className="form-control" />
                            </FormGroup>
      
                            <FormGroup className="form-group col-sm-3">
                              <label className="form-label" htmlFor="total_premium">
                                TOTAL PREMIUM
                              </label>
                              <input type="text" id="total_premium" defaultValue={editproduct.total_premium} name="total_premium" className="form-control" readOnly />
                            </FormGroup>
                          </Row>

                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                        PREVIOUS POLICY NUMBER
                    </label>
                    <input type="text" id="cf-full-name" defaultValue={editproduct.pre_policy_no} name="pre_policy_no" className="form-control" />
                    </FormGroup>

                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                       NAME OF INSURER
                    </label>
                    <select id="cf-full-name" name="pre_policy_insurer" defaultValue={editproduct.pre_policy_insurer} className="form-control">
                        <option value="">Select</option>
                        <option value="Agriculture Insurance Company of India Ltd">Agriculture Insurance Company of India Ltd</option>
                        <option value="Bajaj Allianz General Insurance Co. Ltd">Bajaj Allianz General Insurance Co. Ltd</option>
                        <option value="Cholamandalam MS General Insurance Co. Ltd">Cholamandalam MS General Insurance Co. Ltd</option>
                        <option value="Navi General Insurance Ltd.">Navi General Insurance Ltd.</option>
                        <option value="Future Generali India Insurance Co. Ltd.">Future Generali India Insurance Co. Ltd.</option>
                        <option value="HDFC ERGO General Insurance Co. Ltd">HDFC ERGO General Insurance Co. Ltd</option>
                        <option value="IFFCO-TOKIO General Insurance Co. Ltd.">IFFCO-TOKIO General Insurance Co. Ltd.</option>
                        <option value="ICICI Lombard General Insurance Co. Ltd.">ICICI Lombard General Insurance Co. Ltd.</option>
                        <option value="Kotak Mahindra General Insurance Co. Ltd.">Kotak Mahindra General Insurance Co. Ltd.</option>
                        <option value="Liberty General Insurance Co. Ltd.">Liberty General Insurance Co. Ltd.</option>
                        <option value="Magma HDI General Insurance Co. Ltd.">Magma HDI General Insurance Co. Ltd.</option>
                        <option value="National Insurance Co. Ltd.">National Insurance Co. Ltd.</option>
                        <option value="Raheja QBE General Insurance Co. Ltd.">Raheja QBE General Insurance Co. Ltd.</option>
                        <option value="Reliance General Insurance Co. Ltd.">Reliance General Insurance Co. Ltd.</option>
                        <option value="Royal Sundaram General Insurance Co. Ltd">Royal Sundaram General Insurance Co. Ltd</option>
                        <option value="SBI General Insurance Co. Ltd.">SBI General Insurance Co. Ltd.</option>
                        <option value="Shriram General Insurance Co. Ltd.">Shriram General Insurance Co. Ltd.</option>
                        <option value="Tata-AIG General Insurance Co. Ltd.">Tata-AIG General Insurance Co. Ltd.</option>
                        <option value="The New India Assurance Co. Ltd.">The New India Assurance Co. Ltd.</option>
                        <option value="The Oriental Insurance Co. Ltd.">The Oriental Insurance Co. Ltd.</option>
                        <option value="Universal Sompo General Insurance Co. Ltd.">Universal Sompo General Insurance Co. Ltd.</option>
                        <option value="United India Insurance Co. Ltd.">United India Insurance Co. Ltd.</option>
                        <option value="Acko General Insurance Ltd.">Acko General Insurance Ltd.</option>
                        <option value="Edelweiss General Insurance Company Limited">Edelweiss General Insurance Company Limited</option>
                        <option value="Go Digit General Insurance Limited">Go Digit General Insurance Limited</option>
                        <option value="Aditya Birla Health Insurance Co. Ltd.">Aditya Birla Health Insurance Co. Ltd.</option>
                        <option value="Manipal Cigna Health Insurance Company Limited">Manipal Cigna Health Insurance Company Limited</option>
                        <option value="Niva Bupa Health Insurance Company Limited">Niva Bupa Health Insurance Company Limited</option>
                        <option value="Care Health Insurance Ltd.">Care Health Insurance Ltd.</option>
                        <option value="Star Health & Allied Insurance Co. Ltd.">Star Health & Allied Insurance Co. Ltd.</option>
                    </select>
                    </FormGroup>

                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                         CURRENT POLICY NUMBER
                    </label>
                    <input type="text" id="cf-full-name" defaultValue={editproduct.current_policy_no} name="current_policy_no" className="form-control" />
                    </FormGroup>

                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                       NAME OF INSURER
                    </label>
                    <select id="cf-full-name" name="current_policy_insurer" defaultValue={editproduct.current_policy_insurer} className="form-control">
                        <option value="">Select</option>
                        <option value="Agriculture Insurance Company of India Ltd">Agriculture Insurance Company of India Ltd</option>
                        <option value="Bajaj Allianz General Insurance Co. Ltd">Bajaj Allianz General Insurance Co. Ltd</option>
                        <option value="Cholamandalam MS General Insurance Co. Ltd">Cholamandalam MS General Insurance Co. Ltd</option>
                        <option value="Navi General Insurance Ltd.">Navi General Insurance Ltd.</option>
                        <option value="Future Generali India Insurance Co. Ltd.">Future Generali India Insurance Co. Ltd.</option>
                        <option value="HDFC ERGO General Insurance Co. Ltd">HDFC ERGO General Insurance Co. Ltd</option>
                        <option value="IFFCO-TOKIO General Insurance Co. Ltd.">IFFCO-TOKIO General Insurance Co. Ltd.</option>
                        <option value="ICICI Lombard General Insurance Co. Ltd.">ICICI Lombard General Insurance Co. Ltd.</option>
                        <option value="Kotak Mahindra General Insurance Co. Ltd.">Kotak Mahindra General Insurance Co. Ltd.</option>
                        <option value="Liberty General Insurance Co. Ltd.">Liberty General Insurance Co. Ltd.</option>
                        <option value="Magma HDI General Insurance Co. Ltd.">Magma HDI General Insurance Co. Ltd.</option>
                        <option value="National Insurance Co. Ltd.">National Insurance Co. Ltd.</option>
                        <option value="Raheja QBE General Insurance Co. Ltd.">Raheja QBE General Insurance Co. Ltd.</option>
                        <option value="Reliance General Insurance Co. Ltd.">Reliance General Insurance Co. Ltd.</option>
                        <option value="Royal Sundaram General Insurance Co. Ltd">Royal Sundaram General Insurance Co. Ltd</option>
                        <option value="SBI General Insurance Co. Ltd.">SBI General Insurance Co. Ltd.</option>
                        <option value="Shriram General Insurance Co. Ltd.">Shriram General Insurance Co. Ltd.</option>
                        <option value="Tata-AIG General Insurance Co. Ltd.">Tata-AIG General Insurance Co. Ltd.</option>
                        <option value="The New India Assurance Co. Ltd.">The New India Assurance Co. Ltd.</option>
                        <option value="The Oriental Insurance Co. Ltd.">The Oriental Insurance Co. Ltd.</option>
                        <option value="Universal Sompo General Insurance Co. Ltd.">Universal Sompo General Insurance Co. Ltd.</option>
                        <option value="United India Insurance Co. Ltd.">United India Insurance Co. Ltd.</option>
                        <option value="Acko General Insurance Ltd.">Acko General Insurance Ltd.</option>
                        <option value="Edelweiss General Insurance Company Limited">Edelweiss General Insurance Company Limited</option>
                        <option value="Go Digit General Insurance Limited">Go Digit General Insurance Limited</option>
                        <option value="Aditya Birla Health Insurance Co. Ltd.">Aditya Birla Health Insurance Co. Ltd.</option>
                        <option value="Manipal Cigna Health Insurance Company Limited">Manipal Cigna Health Insurance Company Limited</option>
                        <option value="Niva Bupa Health Insurance Company Limited">Niva Bupa Health Insurance Company Limited</option>
                        <option value="Care Health Insurance Ltd.">Care Health Insurance Ltd.</option>
                        <option value="Star Health & Allied Insurance Co. Ltd.">Star Health & Allied Insurance Co. Ltd.</option>
                    </select>
                    </FormGroup>

                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                       AGENT
                    </label>
                    <input type="text" id="cf-full-name" defaultValue={editproduct.agent} name="agent" className="form-control" />
                    </FormGroup>

                    <Row className="g-gs">
                      <FormGroup className="form-group col-sm-6">
                        <label className="form-label" htmlFor="cf-full-name">
                         MODE OF PAYMENT
                        </label>
                        <input type="text" id="cf-full-name"  defaultValue={editproduct.mode_of_payment} name="mode_of_payment" className="form-control" />
                      </FormGroup>

                      <FormGroup className="form-group col-sm-6">
                        <label className="form-label" htmlFor="cf-full-name">
                        PAYMENT DETAILS
                        </label>
                        <input type="text" id="cf-full-name" defaultValue={editproduct.payment_details} name="payment_details" className="form-control" />
                      </FormGroup>

                    </Row>

                    <FormGroup className="form-group">
                    <label className="form-label" htmlFor="status">
                       STATUS OF POLICY
                    </label>
                    <select id="status" name="policy_status" defaultValue={editproduct.policy_status} className="form-control">
                        <option value="">Select</option>
                        <option value="1">ACTIVE</option>
                        <option value="2">INACTIVE</option>
                        <option value="3">CANCELLED</option>
                        <option value="4">EXPIRED</option>
                    </select>
                  </FormGroup>

                  
                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                      UPLOAD DOCUMENTS
                    </label>
                    <input type="file" id="docs" onChange={onFileChange} className="form-control" multiple />
                  </FormGroup>

                  {
                    editproduct.docs && editproduct.docs.length > 0 ? (
                      <div>
                        <h6>Existing Files:</h6>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <>
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>File Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                              {editproduct.docs.map((doc, index) => (
                                <tr key={index}>
                                  <td><img src={doc} key={index} width={'50px'} height={'50px'}/></td>
                                  <td>
                                  <a key={index} className="delet_img" href="javascript:void(0)" style={{'fontSize':"20px"}} onClick={()=> deletimage(index , editproduct.id)}><Icon name="trash"></Icon></a>
                                  </td>
                                </tr>
                                ))}
                              </tbody>
                            </table>
                            </>
                          
                        </div>
                      </div>
                    ) : null
                  }

                  <FormGroup className="form-group">
                        <label className="form-label" htmlFor="cf-full-name">
                        NOMINEE DETAILS
                        </label>
                        <input type="text" id="cf-full-name" name="nominee" defaultValue={editproduct.nominee} className="form-control" />
                  </FormGroup>

                  <FormGroup className="form-group">
                        <label className="form-label" htmlFor="cf-full-name">
                         NOTES
                        </label>
                        <textarea id="cf-full-name" name="note" defaultValue={editproduct.note} className="form-control" />
                  </FormGroup>

                  <FormGroup className="form-group">
                    <Button disabled={btnloading} type="submit" color="primary" size="lg">
                      {btnloading ? 'Loading...' : 'UPDATE'}
                    </Button>
                  </FormGroup>
                </form>
              </PreviewCard>
            </Col>
          </Row>
        </Block>

      </Content>
    </React.Fragment>
  );
};

export default EditMainSheet;
